import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'

var navLanguagesActive = function(){
	$(".menu-right .languages p").on('click', function(){
    $("p").removeClass("active");
    $(this).addClass("active");
	});
};

// plugin carousel
var slickPlugin = function(){
	$('.slick-home').slick({
		autoplay: true,
  	autoplaySpeed: 4000,
  	pauseOnHover: true,
	});

	$('.slick-main').slick({
		slidesToShow: 2,
		responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        }
      },
		]
	});
};

// collapse footer mobile
var collapseFooter = function(){
	$('.menu-footer .col').each( function(){
		var t = $(this);
		var title = t.find('p');
		var sub = t.find('ul');

		if(sub.length){
			t.addClass('child');
		}

		title.on('click', function(){
			if($(this).parent().hasClass('active')){
				$('.col').removeClass('active');
			}else{
				$('.col').removeClass('active');
				$(this).parent().addClass('active');
			}
		});

	});
};

// menu mobile
var menuMobile = function(){
	$('.menu-bas').each( function(){
		var t = $(this);
		var burger = t.find('.burger');

		burger.on('click', function(){
			if(t.hasClass('active')){
				t.removeClass('active');
			}else{
				t.addClass('active');
			}
		});

	});
};


// adaptative height for each event
var equalHeight = function(){

var maxHeight = 0;

$(".inner").each(function(){
   var thisH = $(this).height();
   if (thisH > maxHeight) { maxHeight = thisH; }
});

	$(".inner").height(maxHeight);

};

// sticky menu
var stickyMenu = function(){

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 144) {
      $('.menu-header .menu-bas').addClass('stickytop');
    }
    else {
      $('.menu-header .menu-bas').removeClass('stickytop');
    }
  });

};

// menu mobile 

var menuMobileSlide = function(){

	$('.menu-bas ul li').each( function(){
		var t = $(this);

		t.on('click', function(){
			if(t.hasClass('active')){
				t.removeClass('active');
			}else{
				$('.menu-bas ul li').removeClass('active');
				t.addClass('active');
			}
    });
    
	});
};


$(document).ready(function(){
	navLanguagesActive();
	slickPlugin();
	collapseFooter();
	menuMobile();
	equalHeight();
	stickyMenu();
	menuMobileSlide();
});